/**
 * LP用カートボタンのリンクを制御する（カート件数が0件のとき非リンク、1件以上のときヘッダーのリンクに変更）
 */
function headerCartLink() {
	// 使用するクラス定義
	const CLS_CART_LINK = 'js-header-cart-link';
	const CLS_CART_LINK_NON_ACTIVE = 'js-header-cart-link-non-active';
	const ID_CART_COUNT_SPAN = 'js-cart-manager-count-span';

	// 初回読み込み時は非リンク化
	$("." + CLS_CART_LINK_NON_ACTIVE).show();
	$("." + CLS_CART_LINK).hide();

	$(document).on('change', "#" + ID_CART_COUNT_SPAN, function() {
		if ($(this).text() >= 1) {
			// カート件数1件以上の時
			$("." + CLS_CART_LINK).show();
			$("." + CLS_CART_LINK_NON_ACTIVE).hide();
		} else {
			// カート件数0件の時
			$("." + CLS_CART_LINK_NON_ACTIVE).show();
			$("." + CLS_CART_LINK).hide();
		}
	});
}

$(function(){
	headerCartLink();
});